import type { CreatureNaturalTraversalInput, CreatureNaturalTraversalResult, CreatureTraversalSpeedSlot } from '../types';
import { phpJsonNumber } from './php-json-values';

function isNatural(slot: CreatureTraversalSpeedSlot): boolean {
    if (slot === null || typeof slot !== 'object' || Array.isArray(slot)) return false;
    const basis = phpJsonNumber(slot.pre_mount ?? slot.total ?? 0);
    return slot.derived !== true && Number.isFinite(basis) && basis > 0;
}

/** Classify authored swim/climb speeds; implicit half-walk and legacy scalar slots are not natural. */
export function classifyCreatureNaturalTraversal(input: CreatureNaturalTraversalInput): CreatureNaturalTraversalResult {
    return {
        naturalSwimming: isNatural(input.swimming),
        naturalClimbing: isNatural(input.climbing),
    };
}
